import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_COURSES, UPDATE_COURSE } from './constants';
import {
  loadCoursesSuccess,
  loadCoursesError,
  updateCourseSuccess,
  updateCourseError,
} from './actions';

import history from 'utils/history';
import requestWrapper from 'utils/requestWrapper';

// utils
import api from "utils/api";
const { endpoint } = api;
import { getObjId } from "utils/helpers/helper.general";
import _local from 'utils/localStorageUtils';


export function* loadMobileCourses(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { role } = currentUser;
    const { options } = action;

    let queryOptions = {
        ...options,
      },
      itemsList = false;
    
    if (role == 'teacher') {
      // we get the campaigns linked to the courses
      itemsList = yield requestWrapper(
        'POST',
        endpoint?.courses?.teacher?.list(getObjId(currentUser)),
        queryOptions,
        currentUser.token,
      );
    } else if (role == 'parent') {
      // we get the campaigns linked to the courses
      itemsList = yield requestWrapper(
        'POST',
        endpoint?.courses?.parent?.list(),
        queryOptions,
        currentUser.token,
      );
    }

    if (!itemsList?.data) {
      yield put(loadCoursesSuccess(false));
    } else {
      yield put(loadCoursesSuccess(itemsList?.data, itemsList?.appointments));
    }
  } catch (error) {
    yield put(loadCoursesError(error));
  }
}

export function* updateCourse(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { courseDetail } = action;

    let updatedCourse = false,
      isNew = !courseDetail.hasOwnProperty('_id');

    if (isNew) {
      updatedCourse = yield requestWrapper(
        'POST',
        endpoint?.courses?.new,
        courseDetail,
        currentUser.token,
      );
    } else {
      updatedCourse = yield requestWrapper(
        'PATCH',
        endpoint?.courses?.update,
        courseDetail,
        currentUser.token,
      );
    }

    if (!updatedCourse) {
      yield put(updateCourseSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        history.push({ pathname: `/сours/${updatedCourse._id}` });
      }
      yield put(updateCourseSuccess(updatedCourse));
    }
  } catch (err) {
    yield put(updateCourseError(true));
  }
}

// Individual exports for testing
export default function* coursesMobileSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_COURSES, loadMobileCourses);
  yield takeLatest(UPDATE_COURSE, updateCourse);
}
